import { useFnsServiceGetSurveyByIdForAdminQuery } from 'zma-react-sdk/fns-service'
import { useTenantStore } from '@/stores/tenantStore'
import { Survey } from '@/features/forms-and-surveys/types'

function useSurveyById(surveyId: string) {
  const { selectedTenantId } = useTenantStore()

  const { data, loading, error } = useFnsServiceGetSurveyByIdForAdminQuery({
    variables: { id: surveyId },
    skip: !surveyId,
    context: {
      headers: {
        'x-tenant-id': selectedTenantId,
      },
    },
  })

  const survey: Survey | undefined = data?.fnsServiceGetSurveyByIdForAdmin

  return {
    data: survey,
    loading,
    error,
  }
}

export { useSurveyById }
